import axios from "axios";
const basicAuth =
  "Basic " +
  btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
const axInstBasic = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Authorization: basicAuth,
  },
});

export {axInstBasic};